import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import AddressForm from './components/AddressForm';
import AddressFormTitle from './components/AddressFormTitle';

const AddressAddPage = () => {
  return (
    <>
      <Helmet>
        <title>Add address | Caltex StarCard</title>
      </Helmet>

      <Box sx={{ padding: '10px 16px' }}>
        <AddressFormTitle title="เพิ่มที่อยู่ใหม่" />
        <AddressForm mode="ADD" />
      </Box>
    </>
  );
};

export default AddressAddPage;
